module.exports = __webpack_public_path__ + "img/pexels-enrique-hoyos-11376668.e988ce6d.jpg";